import styled from "@emotion/styled";

export const HiddenField = styled.input`
  position: absolute;

  height: 1px;
  width: 1px;

  padding: 0;
  border: 0;
  margin: -1px;

  clip: rect(0 0 0 0);
  clip-path: inset(50%);

  overflow: hidden;
  white-space: nowrap;
`;
